import { Link } from "react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Privacy() {
  return (
    <div className="container mx-auto px-4 py-8 max-w-2xl pb-24">
      <div className="mb-6">
        <Link to="/settings">
          <Button variant="ghost" size="sm">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Settings
          </Button>
        </Link>
      </div>

      <h1 className="text-2xl font-bold mb-6">Privacy Policy</h1>

      <div className="prose prose-invert max-w-none space-y-6">
        <p className="text-muted-foreground">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <section>
          <h2 className="text-xl font-semibold mb-3">Information We Collect</h2>
          <p className="text-muted-foreground">
            FlexTrack collects the following information to provide our services:
          </p>
          <ul className="list-disc list-inside text-muted-foreground space-y-2 mt-2">
            <li>
              <strong>Account Information:</strong> Email address and authentication data when you sign in
            </li>
            <li>
              <strong>Location Data:</strong> GPS coordinates during active delivery tracking to calculate mileage
            </li>
            <li>
              <strong>Work Block Data:</strong> Shift times, earnings, tips, and station information you enter
            </li>
            <li>
              <strong>Photos:</strong> Screenshots and images you choose to upload for record-keeping
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">How We Use Your Information</h2>
          <ul className="list-disc list-inside text-muted-foreground space-y-2">
            <li>To track your deliveries and calculate mileage for tax purposes</li>
            <li>To display earnings statistics and analytics</li>
            <li>To sync your data across devices</li>
            <li>To send notifications about your scheduled blocks (if enabled)</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">Data Storage</h2>
          <p className="text-muted-foreground">
            Your data is stored securely on Convex cloud infrastructure. Location data collected during
            tracking is stored locally on your device and synced to our servers for mileage calculations.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">Data Sharing</h2>
          <p className="text-muted-foreground">
            We do not sell, trade, or share your personal information with third parties.
            Your earnings and location data remain private to your account.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">Your Rights</h2>
          <ul className="list-disc list-inside text-muted-foreground space-y-2">
            <li>
              <strong>Access:</strong> You can view all your data within the app
            </li>
            <li>
              <strong>Export:</strong> You can export your data from Settings
            </li>
            <li>
              <strong>Deletion:</strong> You can delete your account and all associated data from Settings
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">Contact</h2>
          <p className="text-muted-foreground">
            For privacy-related questions, please contact us through the app or at the email
            provided in your App Store listing.
          </p>
        </section>
      </div>
    </div>
  );
}
